import { countries } from "countries-list";
import { getCountries } from "libphonenumber-js/min";
import { mergeLeft, assoc } from "ramda";

export const COUNTRY_PICKER_OPTIONS = getCountries()
  .filter(code => countries[code])
  .map(code => ({ label: countries[code].name, value: code }))
  .sort((a, b) => a.label.localeCompare(b.label));

export const COUNTRY_PICKER_STYLES = {
  menuPortal: mergeLeft({ width: 196, zIndex: 99999 }),
  control: mergeLeft({
    border: "none !important",
    cursor: "pointer",
    gap: 4,
  }),
  input: assoc("position", "absolute !important"),
  valueContainer: assoc("padding", "0 !important"),
  indicatorsContainer: assoc("paddingRight", "0 !important"),
};
